export default function Introduction() {
  return (
    <section id="about" data-testid="introduction-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">01 — About the Group</span>
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl leading-[1.1] font-light tracking-[-0.01em]">
            One professional identity. <em className="text-gold not-italic">Seven specialised companies.</em>
          </h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <p className="text-mutedink text-lg md:text-xl leading-relaxed font-light">
            Established in <span className="text-navy font-medium">2020</span>, Salihi Group brings together seven specialised companies operating across legal services, corporate consulting, mining and natural resources, engineering consulting, investment, Oil & Gas, and employment services.
          </p>
          <p className="text-mutedink text-base md:text-lg leading-relaxed mt-6 font-light">
            Each company operates in its own area of expertise while contributing to one professional identity — giving clients access to multiple services through a single, trusted platform.
          </p>
          <div className="mt-10 flex items-center gap-4 pt-8 border-t border-softgray">
            <span className="section-index">— Salihi Group</span>
            <span className="gold-hairline" />
          </div>
        </div>
      </div>
    </section>
  );
}
